import React, { Fragment, useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Search } from 'react-feather'
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Pagination from "./paginador";

const Tablereact = forwardRef((props,ref) => {
    const { pageSize, myClass, minRows = 3 } = props;
    const [myData, setMyData] = useState(props.myData);
    const [dataTmp, setdataTmp] = useState(props.myData);
    const [row, setRow] = useState({});
    const [accion, setAccion] = useState('');
    const [modal, setModal] = useState(false);
    const [deleteWarning, setDeleteWarning] = useState(null);
    var columns = [];
    const [cabecera, setCabecera] = useState(columns);
    const [buscador, setBuscador] = useState('');
    var buscador_tpm=''

    useEffect(()=>{
        if(buscador_tpm.length < buscador.length){
            if(buscador !== '' && buscador !== null)
                setMyData(dataTmp.filter((v) => JSON.stringify(v).toUpperCase().includes(buscador.toUpperCase())))
            else
                setMyData(dataTmp)
        }else{
            if(buscador !== '' && buscador !== null)
                setMyData(myData.filter((v) => JSON.stringify(v).toUpperCase().includes(buscador.toUpperCase())))
            else
                setMyData(dataTmp)
        }
        buscador_tpm=buscador
    },[buscador])

    useEffect(() => {
        setMyData(props.myData) 
        setdataTmp(props.myData)

        columns=[]

        props.cabecera.map(col=>columns.push({
            Header: col.Header,
            accessor: col.accessor,
            style: col.style || {},
            width: col.width || 'auto',
            editable: col.editable || false,
            Cell: col.cell,
            show: col.show === true ?  true: false
        }))
    
        props.eliminar_actualizar && //Pregunta si existe el props eliminar_actualizar
        columns.push({
            Header: <b>Accion</b>,
            id: 'delete', style: { textAlign: 'center' }, sortable: false, width:120, editable:false,
            Cell: (row) => {
                return (
                <div>
                    {/* setAccion('editar');toggle() setAccion('eliminar');toggle() setRow(myData[row.index]);*/}
                    {props.eliminar_actualizar.actualizar? <span onClick={()=>{props.eliminar_actualizar.actualizar(props.myData[row.index])}} title="Actualizar" style={{cursor:'pointer'}}><i className="fa fa-pencil" style={{ width: 35, fontSize: 25, padding: 11, color: '#28a745' }}></i></span>: ''}
                    {props.eliminar_actualizar.eliminar? <span onClick={()=>{openModal('eliminar', props.myData[row.index])}} title="Borrar" style={{cursor:'pointer'}}><i className="fa fa-trash" style={{ width: 35, fontSize: 25, padding: 11, color: '#e4566e' }}></i></span>: ''}
                </div>
            )},
            show: true
        })
    
        props.detalle &&
        columns.push({
            Header: <b>Detalle</b>, id: 'detalle', style: { textAlign: 'center' }, sortable: false, width:100, editable:false,
            Cell: (row) => (
                <div><span onClick={()=>props.detalle(props.myData[row.index])} title='Detalle' style={{cursor:'pointer'}}><i className="fa fa-arrow-right" style={{ width: 35, fontSize: 16, padding: 11, color: 'blue' }}></i></span></div>
            ),
        })

        setCabecera(columns)
    }, [props.myData, props.cabecera]);

    useEffect(() => {

        columns=[]

        props.cabecera.map(col=>columns.push({
            Header: col.Header,
            accessor: col.accessor,
            style: col.style || {},
            width: col.width || 'auto',
            editable: col.editable || false,
            Cell: col.cell,
            show: col.show === true ?  true: false
        }))
    
        props.eliminar_actualizar && //Pregunta si existe el props eliminar_actualizar
        columns.push({
            Header: <b>Accion</b>,
            id: 'delete', style: { textAlign: 'center' }, sortable: false, width:120, editable:false,
            Cell: (row) => {
                return (
                <div>
                    {/* setAccion('editar');toggle() setAccion('eliminar');toggle() setRow(myData[row.index]);*/}
                    {props.eliminar_actualizar.actualizar? <span onClick={()=>{props.eliminar_actualizar.actualizar(myData[row.index])}} title="Actualizar" style={{cursor:'pointer'}}><i className="fa fa-pencil" style={{ width: 35, fontSize: 25, padding: 11, color: '#28a745' }}></i></span>: ''}
                    {props.eliminar_actualizar.eliminar? <span onClick={()=>{openModal('eliminar', myData[row.index])}} title="Borrar" style={{cursor:'pointer'}}><i className="fa fa-trash" style={{ width: 35, fontSize: 25, padding: 11, color: '#e4566e' }}></i></span>: ''}
                </div>
            )},
            show: true
        })
    
        props.detalle &&
        columns.push({
            Header: <b>Detalle</b>, id: 'detalle', style: { textAlign: 'center' }, sortable: false, width:100, editable:false,
            Cell: (row) => (
                <div><span onClick={()=>props.detalle(myData[row.index])} title='Detalle' style={{cursor:'pointer'}}><i className="fa fa-arrow-right" style={{ width: 35, fontSize: 16, padding: 11, color: 'blue' }}></i></span></div>
            ),
        })

        setCabecera(columns)
    }, [myData, props.cabecera]);

    const toggle = () => {
        setModal(prev => {
            const next = !prev;
            if (!next) {
                setDeleteWarning(null);
            }
            return next;
        });
    };

    const openModal = (actionType, item) => {
        setAccion(actionType);
        setRow(item || {});
        if (actionType === 'eliminar' && typeof props.renderDeleteWarning === 'function') {
            setDeleteWarning(props.renderDeleteWarning(item));
        } else if (actionType !== 'eliminar') {
            setDeleteWarning(null);
        }
        setModal(true);
    };
    const actualizarFormulario = e =>setRow({...row,[e.target.name]:e.target.value})

    const eliminarDato = () => {
        props.eliminar_actualizar.eliminar(row)
        toggle()
        setBuscador('')
    }

    const actualizarDato = () => {
        // let rowOld = row.original, sizeRowOld = Object.keys(row.original).length
        // const newData=dataTmp.filter(data=>{
        //     let res = Object.keys(data).filter((y, i) => {
        //         if(data[y])
        //             return data[y].toString().toUpperCase().includes(rowOld[y].toString().toUpperCase())
        //         else
        //             return data[y] === rowOld[y]
        //     }).length 
        //     return res !== sizeRowOld
        // })
        // setMyData([...newData]);
        // setdataTmp([...newData])
    }

    useImperativeHandle(ref, () => ({ setData(dato){ setMyData(arraViejo=>[...arraViejo,dato]); setdataTmp(arraViejo=>[...arraViejo,dato]) }})); //Funcion que puede utilizar el padre
    
    return ( 
        <Fragment>
            <div className="search-form row mb-3">
                {
                    props.buscador &&
                    <div className="col-md-6">
                        <div className="search-wrapper">
                            <Search style={{position:'absolute',top: '10px', left: '40px'}}/>
                            <input className="form-control" type="search" onKeyUp={(e)=>setBuscador(e.target.value)} placeholder={props.buscador} style={{ display: 'inline', marginRight: 40}} />
                        </div>
                    </div>
                }
                {
                    props.boton &&
                    <div className="col-md-6 text-right" >
                        <button className="btn btn-primary" type="button" onClick={props.boton.function} >{props.boton.text}</button>
                    </div>
                }
                {props.viewColumns? <div className="col-md-6 text-right ">
                    <div className="onhover-dropdown text-left" style={{ display: 'inline-block' }}>
                        <div className="media align-items-center" style={{fontSize: 30}}>
                            <i className= "icon-settings"></i>
                        </div>
                        <ul className="notification-dropdown onhover-show-div p-0" style={{width: 450, position: 'absolute', top: 35, left: -450 }}>
                            <li>Columnas mostradas</li>
                            {/* {this.state.actualizarOpcionesTab? this.renderItemsOptions(_this): ''} */}
                            <li style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>
                                {
                                cabecera.map((v, i) => {
                                    return (<span style={{ display: 'inline-block', margin: 5, marginRight: 10}} key={i}><input className="checkbox_animated" id="chk-ani"
                                    name="chk-ani" type="checkbox"  checked={v.show}
                                    onClick={() => { 
                                        let p = cabecera
                                        p[i].show = !p[i].show
                                        setCabecera([...p])
                                    } } onChange={() => {}} />{v.Header} </span>) })
                                }
                            </li>
                            <li onClick={() => { }}>Reiniciar Ajustes</li>
                        </ul>
                    </div>
                </div>: ''}
            </div>
    
            <ReactTable 
                className={myClass}
                data={myData} 
                columns={cabecera} 
                PaginationComponent={Pagination}
                defaultPageSize={pageSize}
                minRows={minRows}
                showPagination={props.paginacion}
                showFilters={props.showFilters? true: false}
                filterable={props.showFilters? true: false}
                nextText='Siguiente'
                pageText='Página'
                pageJumpText='Saltar página'
                loadingText='Cargando...'
                previousText='Atrás'
                ofText='de'
                rowsText='Filas'
                noDataText='No hay registro'
                style={{fontFamily: 'Arial', fontSize: 15}}
                // filterable={true}
                // defaultFilterMethod={(filter, row) =>
                //     console.log(filter, row)
                //     // String(row[filter.id]) === filter.value
                // }
                />
                
            <Modal isOpen={modal} toggle={toggle} className={`modal-body ${accion=='eliminar' && 'modal-lg'}`} centered={true}>
                <ModalHeader toggle={toggle}>{ accion=='editar' ? 'Editar elemento':'Borrar elemento'}</ModalHeader>
                <ModalBody>
                    {
                        accion=='editar' ?
                        <form>
                            {
                                columns.map((col,i)=>{
                                    if(col.editable){
                                        return (
                                            <div key={i} className="col-sm-12 col-md-12 mb-3">
                                                <label className='form-label'>{col.Header.props.children}</label>
                                                <input className='form-control' type="text" name={col.accessor} value={row[col.accessor]} onChange={actualizarFormulario} />                                           
                                            </div>
                                        )
                                    }
                                })
                            }
                        </form>
                        :
                        <Fragment>
                            {deleteWarning && (
                                <div className="alert alert-warning" role="alert">
                                    {deleteWarning}
                                </div>
                            )}
                            <div className="mb-2 text-center"><strong style={{fontSize:'18px'}}>¿Estás seguro que deseas borrar este elemento?</strong></div>
                            <ReactTable data={[row]} columns={cabecera} defaultPageSize={1} className={myClass} showPagination={false} />
                        </Fragment>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={()=>{ accion == 'editar' ? actualizarDato() : eliminarDato() }}>{accion == 'editar' ? 'Actualizar':'Confirmar'}</Button>
                    <Button color="secondary" onClick={toggle}>Cancelar</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
})
 
export default Tablereact;
